import {
    FETCH_All_GAME_PARENT, GET_GAME_PARENT_DATA, LOAD_GAME_PARENTES, ERROR_LOADING_GAME_PARENTES,
    ERROR_LOADING_GAME_PARENT, LOAD_GAME_PARENT, SAVE_GAME_PARENT, ERROR_ADDING_GAME_PARENT,
    ERROR_SETTING_STATE_GAME_PARENT, SETTING_STATE_GAME_PARENT,
    ERROR_DELETING_GAME_PARENT, DELETING_GAME_PARENT,
    ERROR_UPDATE_GAME_PARENT, UPDATE_GAME_PARENT, EMPTY_GAME_PARENT, EMPTY_GAME_PARENT_WITH_DATA,
    ADD_GAME_PARENT_WITH_SENTFROM
}
    from './Types'

import axios, { post } from 'axios'

export const addGameParentItemWithSentFrom = (item, sentFrom) => dispatch => {

    const gameParent = {
        item: item,
        sentFrom: sentFrom
    }
    dispatch({
        type: ADD_GAME_PARENT_WITH_SENTFROM,
        payload: gameParent
    })
}


export const fetchAllGameParent = () => dispatch => {

    dispatch({
        type: LOAD_GAME_PARENTES,
        payload: 'loading'
    })

    axios.get('/GameParent/getAllGameParentList')
        .then((res) => {
            dispatch({
                type: FETCH_All_GAME_PARENT,
                payload: res.data
            })
        }
        ).catch((Error) => {
            dispatch({
                type: ERROR_LOADING_GAME_PARENTES,
                payload: Error.message
            })
        })
}

export const getGameParentData = (id) => {
    return (dispatch, getState, { getFirebase }) => {
        const firebase = getFirebase();
        firebase.auth().currentUser.getIdToken().then((token) => {
            dispatch({
                type: LOAD_GAME_PARENT,
                payload: 'loading'
            })
            const url = "/GameParent/getGameParentDetails"
            const formData = new FormData();
            formData.append('ID', id);
            const config = {
                headers: {
                    'content-type': 'application/x-www-form-urlencoded; charset=utf-8',
                    'X-Authorization-Firebase': token
                }
            }
            post(url, formData, config).then((res) => {
                dispatch(
                    {
                        type: GET_GAME_PARENT_DATA,
                        payload: res.data
                    }
                )
            }).catch((Error) => {
                dispatch({
                    type: ERROR_LOADING_GAME_PARENT,
                    payload: Error.message
                })
            })


        })

    }
}

export const saveGameParent = (name, description, imgURL, publish_date, audio, promo_with_music, promo_without_music, name_in_english, description_in_english, featured) => {
    return (dispatch, getState, { getFirebase }) => {
        const firebase = getFirebase();
        firebase.auth().currentUser.getIdToken().then((token) => {

            dispatch({
                type: LOAD_GAME_PARENT,
                payload: 'loading'
            })

            const url = '/GameParent/addGameParent';
            const formData = new FormData();
            formData.append('Name', name);
            formData.append('Description', description);
            formData.append('Status', "SUSPENDED");
            formData.append('Image', imgURL);
            formData.append('Publish_Date', publish_date);
            formData.append('Voice', audio);
            formData.append('Promo_Video_With_Music', promo_with_music);
            formData.append('Promo_Video_Without_Music', promo_without_music);
            formData.append('Name_In_English',name_in_english);
            formData.append('Description_In_English', description_in_english);
            formData.append('featured', featured);
            const config = {
                headers: {
                    'X-Authorization-Firebase': token
                }
            }
            post(url, formData, config).then((res) => {
                dispatch(
                    {
                        type: SAVE_GAME_PARENT,
                        payload: res.data
                    }
                )
            }).catch((Error) => {
                dispatch({
                    type: ERROR_ADDING_GAME_PARENT,
                    payload: Error.message
                })
            })
        })


    }
}

export const setStateGameParent = (id, state) => {
    return (dispatch, getState, { getFirebase }) => {
        const firebase = getFirebase();
        firebase.auth().currentUser.getIdToken().then((token) => {
            dispatch({
                type: LOAD_GAME_PARENT,
                payload: 'loading'
            })

            const url = "/GameParent/setGameParentStatus";
            const formData = new FormData();
            formData.append('ID', id);
            formData.append('Status', state);

            const config = {
                headers: {
                    'content-type': 'application/x-www-form-urlencoded; charset=utf-8',
                    'X-Authorization-Firebase': token
                }
            }
            post(url, formData, config).then((res) => {
                dispatch(
                    {
                        type: SETTING_STATE_GAME_PARENT,
                        payload: res.data
                    }
                )
            }).catch((Error) => {
                dispatch({
                    type: ERROR_SETTING_STATE_GAME_PARENT,
                    payload: Error.response.data.message//Error.message
                })
            })
        })

    }
}

export const deleteGameParent = (id) => {
    return (dispatch, getState, { getFirebase }) => {
        const firebase = getFirebase();
        firebase.auth().currentUser.getIdToken().then((token) => {
            dispatch({
                type: LOAD_GAME_PARENT,
                payload: 'loading'
            })

            const url = "/GameParent/deleteGameParent";
            const formData = new FormData();
            formData.append('ID', id);
            const config = {
                headers: {
                    'content-type': 'application/x-www-form-urlencoded; charset=utf-8',
                    'X-Authorization-Firebase': token
                }
            }
            post(url, formData, config).then((res) => {
                dispatch(
                    {
                        type: DELETING_GAME_PARENT,
                        payload: res.data
                    }
                )
            }).catch((Error) => {
                dispatch({
                    type: ERROR_DELETING_GAME_PARENT,
                    payload: Error.message
                })
            })
        })

    }
}

export const updateGameParent = (id, name, description, status, imageUrl, publishDate, audio,
     promo_with_music, promo_without_music, name_in_english, description_in_english, featured) => {
    return (dispatch, getState, { getFirebase }) => {

        const firebase = getFirebase();
        firebase.auth().currentUser.getIdToken().then((token) => {
            dispatch({
                type: LOAD_GAME_PARENT,
                payload: 'loading'
            })

            const url = "/GameParent/updateGameParent";
            const formData = new FormData();
            formData.append('ID', id);
            formData.append('Name', name);
            formData.append('Description', description);
            formData.append('Image', imageUrl);
            formData.append('Status', "");
            formData.append('Publish_Date', publishDate);
            formData.append('Voice', audio);
            formData.append('Promo_Video_With_Music', promo_with_music);
            formData.append('Promo_Video_Without_Music', promo_without_music);
            formData.append('Description_In_English', description_in_english);
            formData.append('Name_In_English', name_in_english);
            formData.append('featured', featured);
            const config = {
                headers: {
                    'content-type': 'application/x-www-form-urlencoded; charset=utf-8',
                    'X-Authorization-Firebase': token
                }
            }
            post(url, formData, config).then((res) => {
                dispatch(
                    {
                        type: UPDATE_GAME_PARENT,
                        payload: res.data
                    }
                )
            }).catch((Error) => {
                dispatch({
                    type: ERROR_UPDATE_GAME_PARENT,
                    payload: Error.message
                })
            })
        })

    }
}


export const emptyGameParentWithGames = () => dispatch => {
    dispatch({
        type: EMPTY_GAME_PARENT_WITH_DATA,
        payload: ""
    })
}

export const emptyError = () => dispatch => {
    dispatch({
        type: EMPTY_GAME_PARENT,
        payload: ""
    })
}
